import React,{ useState, useEffect } from 'react';
//import '../css/dashboard.scss'


import {  Link } from "react-router-dom";
//import '../App.css';
import logo from 'assets/logo.png';
import Sidebar from 'components/adminLte/sidebar/Sidebar';
import Item from 'components/adminLte/sidebar/Item';
import Header from 'components/adminLte/sidebar/Header';
//--- CONTEXT API -----------
import { useStore, useDispatch } from "store/StoreProvider";
import { types } from "store/StoreReducer";

import { useFieldArray } from 'react-hook-form';
import AuthService from "services/auth.service";
import { useNavigate } from "react-router-dom";

const SidebarLte =()=>{

  const [itemSel, setItemSel] = useState('');
  //---------------- CONTEXT API ------------------
  const store = useStore();
  const dispatch = useDispatch();
  const {user, materia} = store;

  const navigate = useNavigate();

  //-----se dispara en el montaje del componente
  useEffect( () => {
    if(materia==null){
      logout();
    }
  }, [] );
  //---------------------
  const logout=()=>{
    console.log("logout");

    AuthService.logout();
    navigate("/login");
    //let history = useHistory();
    //history.push("/login");
    dispatch({type: types.authLogout})
  }
  //------------------------
  let handleToggle=(id)=>{
      if(id!=""){
          setItemSel(id);
      }    
  }
  //====================================RENDER
    return(
        <aside className="main-sidebar">
        {/*<!-- sidebar: style can be found in sidebar.less -->*/}
        <Sidebar 
        >
          <div className="p-2" style={{backgroundColor: '#1a2226' }}>
            <Link to="#" className="" style={{color: 'seagreen' }}>
              <h4 className="list-group-item-heading" style={{ textWrap: 'initial'}}>
                {materia?.nombre}/G{materia?.grupo}
              </h4>
            </Link>
          </div>
          <Item
            icon="fa-users"
            text="Lista de estudiantes."
            to="/estudiantes"
          />

          <Item
            icon="fa-list"
            text="Materias"
            to="/cursosd_sel_list"
          />
          
          <Header text="MENÚ" />

          {/*
          <Item
            icon="fa fa-fw fa-file-movie-o"
            text="Temas"
            to="/temas"
            
          />
          */}
          {/*<Item
            icon="fa fa-fw fa-file-movie-o"
            text="Actividades/Recursos"
            to="/demodatatable"
            
          />*/}

          {/*<Item  
            text="Examenes" 
            icon="fa-list-ol"
            labels=""
            id="id_exa"
            activeOn={ itemSel=="id_exa"?  true:false}
            handleToggle={handleToggle}
          >
            <Item text="Tabla de examenes" to="/perfil" />
            <Item text="Revisar examen" to="/dashboardv2" />
            <Item text="Buscar examen" to="/dashboardv2" />
            <Item text="Anular examen" to="/dashboardv2" />
          </Item>*/}

          <Item  
            text="Notas" 
            icon="fa-list-ol"
            labels=""
            id="id_nota"
            activeOn={ itemSel=="id_nota"?  true:false}
            handleToggle={handleToggle}
          >
            <Item text="Notas" to="/notasd" />
            
          
          </Item>

          
          <Item  
            text="Examenes" 
            icon="fa-fw fa-list-ol"
            labels=""
            id="id_exa"
            activeOn={ itemSel==="id_exa"?  true:false}
            handleToggle={handleToggle}
            >
            <Item text="Tabla examenes" to="/examend_list" />
            <Item text="Revisar examen" to="/examend_rev_list" />
            <Item text="Buscar examen por CI" to="/dashboardv2" />
            <Item text="Anular examen" to="/tarea_rev_list" />
          </Item>
          
          <Item  
            text="Tareas" 
            icon="fa-edit"
            labels=""
            id="id_tarea"
            activeOn={ itemSel=="id_tarea"?  true:false}
            handleToggle={handleToggle}
          >
            <Item text="Tabla tareas" to="/taread_list" />
            <Item text="Habilitar tarea" to="/dashboardv2" />
            <Item text="Buscar tarea por CI" to="/dashboardv2" />
            <Item text="Revisar tarea" to="/tarea_rev_list" />
            <Item text="Calificaciones" to="/dashboardv2" />
          </Item>
          

          <Item  
            text="Asistencias" 
            icon="fa-edit"
            labels=""
            id="id_asis"
            activeOn={ itemSel=="id_asis"?  true:false}
            handleToggle={handleToggle}
          >
            <Item text="Tabla asistencias" to="/tabla_asistencia" />
            
            <Item text="Fechas de asistencias" to="/asistencia2_fecha" />
          </Item>


         
          
          <Header text="HERRAMIENTAS" />
          
          <Item
            icon="fa fa-binoculars"
            text="Buscar estudiante"
            to="/estud_buscar"
            
          />

          <Item
            icon="fa fa-users"
            text="Cambiar Clave"
            to="/cambiar_claved"
            
          />

          <Item
            icon="fa fa-cogs"
            text="Configuración"
            to="/configd"
          />

          

        </Sidebar>

        
        {/*<!-- /.sidebar -->*/}
      </aside>
    );
}

export default SidebarLte;